import { useState } from "react";
import { Divider, Grid } from "@mzc-pdc/ui";
import { styled } from "@mui/material";
import theme from "@styles/theme";
import Typography from "@components_v2/typography/typography";
import convertToByte from "@cores/convertToByte";
import StatusBadge from "@components_v2/status-badge/status-badge";

const Actions = styled(Grid)(({ theme }) => ({
    position: `absolute`,
    right: `10px`,
    top: `10px`,
    width: `auto`,
    padding: `0`,
}));

export const AssetInformation = ({ status, extensions, size }) => {
    return (
        <Typography variant={"body3Regular"} color={theme.palette.secondary[600]}>
            <Grid container sx={{ "& > *": { marginRight: "6px !important" } }}>
                {status && (
                    <Grid item sx={{ display: "flex", width: "22px", justifyContent: "center", alignItems: "center" }}>
                        <StatusBadge status={status} />
                    </Grid>
                )}
                {extensions && (
                    <Grid item sx={{ display: "flex", justifyContent: "center" }}>
                        <Typography variant={"body3_400"} color={theme.palette.greySecondary[600]}>
                            {extensions}
                        </Typography>
                    </Grid>
                )}
                {size >= 0 && (
                    <>
                        {(status || extensions) && <Divider orientation={"vertical"} flexItem />}
                        <Grid item sx={{ display: "flex", justifyContent: "center" }}>
                            <Typography variant={"body3_400"} color={theme.palette.greySecondary[600]}>
                                {convertToByte(size, true)}
                            </Typography>
                        </Grid>
                    </>
                )}
            </Grid>
        </Typography>
    );
};

const ListCard = ({ width, checkbox, thumbnail, name, subName, actions, onClickCard, onDoubleClickCard }) => {
    const [isHover, setIsHover] = useState(false);

    return (
        <Grid
            item
            onClick={onClickCard}
            onDoubleClick={onDoubleClickCard}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            <Grid
                item
                flexDirection={"row"}
                sx={{
                    position: "relative",
                    width: width ?? "202px",
                    height: "288px",
                    borderRadius: "8px",
                }}
            >
                <Grid
                    item
                    sx={{
                        position: "absolute",
                        zIndex: 1,
                        display: `flex`,
                    }}
                >
                    {checkbox && checkbox}
                </Grid>
                {thumbnail && thumbnail}
                <Grid item mt={2}>
                    <Grid container flexDirection={"column"} pl={1} pr={1}>
                        <Grid container flexDirection={"row"} alignItems={"center"} sx={{ mb: 1 }} wrap="nowrap">
                            <Grid
                                item
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    overflow: "hidden",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                            >
                                {name?.startIcon && (
                                    <Grid item sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                                        {name.startIcon}
                                    </Grid>
                                )}
                                {name?.name && (
                                    <Grid
                                        item
                                        sx={{
                                            flex: "1",
                                            minWidth: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            "> span": {
                                                display: "inline-block",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                            },
                                        }}
                                    >
                                        <Typography variant={"body1_500"}>{name.name}</Typography>
                                    </Grid>
                                )}
                                {name?.endIcon && (
                                    <Grid item sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                                        {name.endIcon}
                                    </Grid>
                                )}
                            </Grid>
                            <Grid item sx={{ flexShrink: 0, ml: 1, display: "flex" }}>
                                {name?.badge && name?.badge}
                            </Grid>
                        </Grid>
                        <Grid container flexDirection={"row"} alignItems={"center"}>
                            <Grid item flex={1}>
                                {subName?.name && subName?.name}
                            </Grid>
                            <Grid item>{subName?.icons && subName?.icons}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {actions && <Actions className={"actions"}>{isHover && <>{actions}</>}</Actions>}
            </Grid>
        </Grid>
    );
};
ListCard.propTypes = {};

export default ListCard;
